import React from 'react';
import { Home, Droplets, Sun, Fence, Building2, Waves } from 'lucide-react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
const services = [{
  title: 'Driveway & Concrete Cleaning',
  description: 'Remove years of dirt, oil stains, and grime to restore your concrete surfaces.',
  icon: Droplets
}, {
  title: 'House & Siding Washing',
  description: 'Safe soft-washing techniques that eliminate algae and mildew without damaging siding.',
  icon: Home
}, {
  title: 'Roof Soft Washing',
  description: 'Protect your roof lifespan by safely removing black streaks and moss.',
  icon: Sun
}, {
  title: 'Deck & Patio Cleaning',
  description: 'Revitalize wood and composite decks to prepare them for staining or sealing.',
  icon: Waves
}, {
  title: 'Fence Washing',
  description: 'Strip away gray weathering and organic growth from wood or vinyl fences.',
  icon: Fence
}, {
  title: 'Commercial Pressure Washing',
  description: 'Keep your storefront, parking lot, or commercial property looking professional.',
  icon: Building2
}];
export function Services() {
  const scrollToQuote = () => {
    document.getElementById('quote')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="services" className="py-20 md:py-32 bg-white" data-id="element-153">
      <div className="container mx-auto px-4 md:px-6" data-id="element-154">
        <div className="text-center mb-16" data-id="element-155">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-primary mb-4 uppercase" data-id="element-156">
            What We Clean
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto" data-id="element-157" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-158">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <Card key={index} className="p-8 border-2 border-muted hover:border-accent/50 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl bg-white group" data-id="element-159">
                <div className="w-14 h-14 bg-primary/5 rounded-lg flex items-center justify-center mb-6 group-hover:bg-accent/10 transition-colors" data-id="element-160">
                  <Icon className="w-8 h-8 text-accent" data-id="element-161" />
                </div>
                <h3 className="font-heading text-2xl font-bold text-primary mb-3" data-id="element-162">
                  {service.title}
                </h3>
                <p className="text-muted-foreground text-lg leading-relaxed" data-id="element-163">
                  {service.description}
                </p>
              </Card>;
        })}
        </div>

        <div className="mt-16 text-center bg-muted/50 rounded-2xl p-8 max-w-3xl mx-auto border border-border" data-id="element-164">
          <h3 className="font-heading text-2xl font-bold text-primary mb-4" data-id="element-165">
            Don't see your service? We probably do it.
          </h3>
          <Button onClick={scrollToQuote} size="lg" className="bg-primary hover:bg-primary/90 text-white font-bold h-12 px-8 w-full sm:w-auto" data-id="element-166">
            Contact Us
          </Button>
        </div>
      </div>
    </section>;
}